const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/role/$permissionSetId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/role/$permissionSetId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { PermissionSetDetailPendingState } from '@/features/user-management/components/PermissionSetDetailPendingState';
import { userManagementPermissionSetsQuery } from '@/features/user-management/services/userManagementQueries';
import { createFileRoute, notFound } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/user-management/role/$permissionSetId')({
  loader: async ({
    context,
    params
  }) => {
    const response = await context.queryClient.ensureQueryData(userManagementPermissionSetsQuery);
    if (!response.permissionSets.some(permissionSet => permissionSet.id === params.permissionSetId)) {
      throw notFound();
    }
  },
  pendingComponent: PermissionSetDetailPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});